<template>
    <div class="page" v-loading="loading">
        <div class="self-info-container">
            <el-tabs tab-position="left" v-model="activeName" class="modern-tabs">
                <el-tab-pane name="personalInfo">
                    <span slot="label"><i class="el-icon-user"></i> 个人信息</span>
                    <personalInfo :userInfo="userInfo"></personalInfo>
                </el-tab-pane>
                <el-tab-pane name="changeInfo">
                    <span slot="label"><i class="el-icon-edit"></i> 更新信息</span>
                    <changeInfo :userInfo="userInfo" @successChange="successChange"></changeInfo>
                </el-tab-pane>
                <el-tab-pane name="changePassWord">
                    <span slot="label"><i class="el-icon-unlock"></i> 修改密码</span>
                    <changePassWord :userId="userInfo.id"></changePassWord>
                </el-tab-pane>
                <el-tab-pane name="classDetails">
                    <span slot="label" @click="classVisible=true"><i class="el-icon-notebook-2"></i> 我的课程</span>
                    <classDetails v-if="classVisible"></classDetails>
                </el-tab-pane>
                <el-tab-pane name="personalNews">
                    <span slot="label" @click="personalVisible=true"><i class="el-icon-camera"></i> 个人动态</span>
                    <personalNews v-if="personalVisible"></personalNews>
                </el-tab-pane>
                <el-tab-pane name="pointsDetails">
                    <span slot="label" @click="pointVisible=true"><i class="el-icon-star-off"></i> 积分明细</span>
                    <pointsDetails v-if="pointVisible"></pointsDetails>
                </el-tab-pane>
                <el-tab-pane name="messageCenter">
                    <span slot="label" @click="messageVisible=true"><i class="el-icon-message"></i> 消息中心</span>
                    <messageCenter v-if="messageVisible"></messageCenter>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import personalInfo from "./components/personalInfo.vue"
    import changeInfo from "./components/changeInfo.vue"
    import changePassWord from "./components/changePassWord.vue"
    import personalNews from "./components/personalNews.vue"
    import classDetails from "./components/classDetails.vue"
    import pointsDetails from "./components/pointsDetails.vue"
    import messageCenter from "./components/messageCenter.vue"
    import {selfInfo} from "@/api/index.js"

    export default {
        components: {
            personalInfo,
            changeInfo,
            changePassWord,
            personalNews,
            classDetails,
            pointsDetails,
            messageCenter
        },
        data() {
            return {
                activeName: 'personalInfo', // 默认展示第二个tab
                userInfo: {},
                loading: false,
                classVisible: false,
                personalVisible: false,
                pointVisible: false,
                messageVisible: false,
            }
        },
        mounted() {
            this.activeName = this.$route.params.activeName;
            if (this.activeName ==='' || this.activeName === undefined){
                this.activeName='personalInfo';
            }
            if (this.activeName === 'classDetails') {
                this.classVisible = true;
            }
            this.getInfo()
        },
        methods: {

            getInfo() {
                this.loading = true;
                selfInfo().then(res => {
                    if (res.code === "0000") {
                        this.userInfo = res.data
                        this.loading = false;
                    }
                });
            },
            successChange() {
                this.getInfo()
            }
        }
    }
</script>

<style scoped>
.self-info-container {
    margin: 30px auto;
    margin-bottom: 50px;
    max-width: 1400px;
    background: #FFFFFF;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

/* 左侧导航区域 */
.modern-tabs ::v-deep .el-tabs__header.is-left {
    margin-right: 0;
}

.modern-tabs ::v-deep .el-tabs__nav-wrap {
    background: transparent;
    padding: 0;
}

.modern-tabs ::v-deep .el-tabs__nav-wrap::after {
    display: none;
}

.modern-tabs ::v-deep .el-tabs__nav {
    padding: 0;
    border-right: 1px solid #EBEEF5;
    padding-right: 20px;
}

.modern-tabs ::v-deep .el-tabs__item {
    height: 44px;
    line-height: 44px;
    padding: 0 20px;
    margin: 4px 0;
    border: none;
    color: #606266;
    font-size: 14px;
    transition: all 0.25s ease;
    border-radius: 8px;
    text-align: left;
}

.modern-tabs ::v-deep .el-tabs__item i {
    margin-right: 10px;
    font-size: 15px;
    color: #909399;
    transition: color 0.25s ease;
}

.modern-tabs ::v-deep .el-tabs__item:hover {
    background: #F5F7FA;
    color: #409EFF;
}

.modern-tabs ::v-deep .el-tabs__item:hover i {
    color: #409EFF;
}

.modern-tabs ::v-deep .el-tabs__item.is-active {
    color: #409EFF;
    background: #ECF5FF;
    font-weight: 500;
}

.modern-tabs ::v-deep .el-tabs__item.is-active i {
    color: #409EFF;
}

.modern-tabs ::v-deep .el-tabs__active-bar {
    display: none;
}

.modern-tabs ::v-deep .el-tabs__content {
    min-height: 600px;
    padding-left: 30px;
}

</style>
